import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full grid grid-cols-1 pb-10 md:grid-cols-2 gap-2 md:gap-4 mt-10" }

import { useAddProject } from '@/store/addProject'
import { useType } from '@/store/type'
import DynamicInputAdditionalField from '../../dynamicInputAdditionalField.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AdditionalDataInput',
  setup(__props) {

const typeStore = useType()
const addProjectStore = useAddProject()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(typeStore).getOneAdditionalDataType(_unref(addProjectStore).projectActiveData.type)!.fields, (field) => {
      return (_openBlock(), _createBlock(DynamicInputAdditionalField, {
        "show-title": true,
        key: field.id,
        "additional-data-field": field
      }, null, 8, ["additional-data-field"]))
    }), 128))
  ]))
}
}

})